import { render } from "./MonsterBox.vue?vue&type=template&id=0fc8d800&scoped=true"
import script from "./MonsterBox.vue?vue&type=script&lang=js"
export * from "./MonsterBox.vue?vue&type=script&lang=js"

import "./MonsterBox.vue?vue&type=style&index=0&id=0fc8d800&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fc8d800"]])

export default __exports__